namespace Solovis.Reports.ReportHelpers.ReportLibrary {

  export class ReportLibraryReportGenerator {

    public static generateReportDefinition() {

      let showAddNewReportInterface = function (options) {
        Solovis.ModuleLoader.modalEnsureModuleListLoaded(["Solovis.ReportEditors"], function () {
          (Solovis.Site as any).ReportEditors.showAddReportInterface(options);
        });
      };

      let report = null;

      if (Solovis.UX.Utils.isNewUxEnabled()) {
        report = {
          autoRun: true,
          fullWidth: true,
          autoSizeSpaceAvailable: true,
          collapseConfigSection: true,

          parameters: [
          ],

          root: {
            elementName: "Root",
            layout: "Vertical",

            children: [
              {
                partControl: "Solovis.Reports.Parts.HtmlControl",

                settings: {
                  render: function () {
                    Solovis.UX.Utils.placeComponent("ReportLibraryPage",
                      this.container[0],
                      {},
                    );
                    return;
                  }
                }
              }
            ]
          }
        };
      }
      else {
        report = {
          autoRun: true,
          fullWidth: true,
          autoSizeSpaceAvailable: true,
          collapseConfigSection: true,

          parameters: [
          ],

          root: {
            elementName: "Root",
            layout: "Vertical",

            children: [
              {
                partControl: "Solovis.Reports.Parts.HtmlControl",

                style: { height: "100%" },

                settings: {
                  render: function () {
                    let self = this;

                    let userHasReportEditPermission = Solovis.Portal.CachedPermissions.doesUserHavePermission("ReportEdit");

                    if (this.reportControl.isTopLevelReportControl() && userHasReportEditPermission) {
                      var actionBarRegion = Solovis.Site.ActionBar.getOrCreateRegion("ReportLibrary");

                      var addLink = $("<button>")
                        .text("Add Report")
                        .click(function () {
                          showAddNewReportInterface({
                            saveCallback: function (savedReportModel) {
                              (Solovis.Site as any).ReportEditors.navigateToReportEditor(savedReportModel.code);
                            }
                          });
                        });

                      actionBarRegion.setHtml(addLink);
                    }

                    this.__libraryDisplayControl = new ReportLibraryDisplayControl({
                      controlHost: this.container,
                      reportControl: this.reportControl,
                      reportListDataSet: this.dataSets.reportList
                    });
                    this.__libraryDisplayControl.setAsCurrentControl();
                  },

                  onReportAvailableSpaceUpdate: function () {
                    this.__libraryDisplayControl.updateSpaceAvailable();
                  }
                },

                dataSources: [
                  { name: "reportList", ref: { elementName: "Root", dataSourceName: "reportList" } }
                ]
              }
            ],

            dataSources: [
              {
                name: "reports",
                path: "/Solovis/Reports/CurrentUserReports",

                parameterMap: function (parameters) {
                  return {};
                }
              },
              {
                name: "featuredLinks",
                path: "/Solovis/Site/CurrentUserFeaturedLinks",
                parameterMap: function (parameters) {
                  return {};
                }
              },
              {
                name: "reportList",
                data: {},

                dependsOn: [
                  { name: "reports", ref: { elementName: "Root", dataSourceName: "reports" } },
                  { name: "featuredLinks", ref: { elementName: "Root", dataSourceName: "featuredLinks" } }
                ],

                postProcess: (loadedDataSet, more) => {
                  let reportsDataSet = more.dataSets.reports;
                  let horizonPerformanceCode = "C893BA48-0516-4C7C-929C-3FF730164518"
                  let reports = ((reportsDataSet && reportsDataSet.reports) ? reportsDataSet.reports : []).filter(report => report.code !== horizonPerformanceCode);

                  let featuredLinksDataSet = more.dataSets.featuredLinks;
                  let featuredLinks = (featuredLinksDataSet && featuredLinksDataSet.links) ? featuredLinksDataSet.links : [];

                  let parseLevels = (path) => {
                    let levels = [];

                    if (path) {
                      let parts = path.split("/");
                      if (parts) {
                        for (let part of parts) {
                          if (part) {
                            part = part.trim();
                            if (part) {
                              levels.push(part);
                            }
                          }
                        }
                      }
                    }

                    return levels;
                  };

                  let linkEntryList = [];
                  let reportEntryList = [];

                  for (let link of featuredLinks) {
                    let categoryLevels = parseLevels(link.category);
                    let levels = categoryLevels.concat(link.name ? link.name.trim() : "");

                    levels = [(link.isShared ? "Featured Links (Shared)" : "Featured Links")].concat(levels);

                    let levelsLowerCase = _.map(levels, (level) => level.toLowerCase())

                    let name = "";
                    let category = null;

                    if (levels.length > 0) {
                      name = levels[levels.length - 1];
                      category = levels.slice(0, levels.length - 1).join("/");
                    }

                    let entry = {
                      name: name,
                      category: category,
                      isFeaturedLink: true,
                      link: link,
                      levels: levels,
                      levelsLowerCase: levelsLowerCase
                    };

                    linkEntryList.push(entry);
                  }

                  for (let report of reports) {
                    let levels = parseLevels(report.path);
                    let levelsLowerCase = _.map(levels, (level) => level.toLowerCase())

                    let name = "";
                    let category = null;

                    if (levels.length > 0) {
                      name = levels[levels.length - 1];
                      category = levels.slice(0, levels.length - 1).join("/");
                    }

                    let entry = {
                      name: name,
                      category: category,
                      isReport: true,
                      report: report,
                      levels: levels,
                      levelsLowerCase: levelsLowerCase
                    };

                    reportEntryList.push(entry);
                  }

                  let entrySorter = (a, b) => {
                    for (let i = 0; i < a.levels.length; i++) {
                      if (i < b.levels.length) {
                        if (a.levelsLowerCase[i] < b.levelsLowerCase[i]) {
                          return -1;
                        }
                        else if (a.levelsLowerCase[i] > b.levelsLowerCase[i]) {
                          return 1;
                        }
                      }
                      else {
                        break;
                      }
                    }

                    if (a.levels.length < b.levels.length) {
                      return -1;
                    }
                    else if (a.levels.length > b.levels.length) {
                      return 1;
                    }
                    else {
                      return 0;
                    }
                  };

                  linkEntryList.sort(entrySorter);
                  reportEntryList.sort(entrySorter);

                  let entryList = linkEntryList.concat(reportEntryList);

                  let rootNode = {
                    name: "/",
                    entryList: [],
                    fullPath: "",

                    nodes: [],
                    nodeNameLowerToNodeMap: {}
                  };

                  let placeEntryInNode = function (node, entry, levelIndex) {
                    entry.nodeId = entry.name + "---" + (entry.category ? ("---" + entry.category) : "");

                    if (levelIndex >= (entry.levels.length - 1)) {
                      node.entryList.push(entry);
                    }
                    else {
                      let levelLowerCase = entry.levelsLowerCase[levelIndex];
                      let level = entry.levels[levelIndex];

                      let childNode = node.nodeNameLowerToNodeMap[levelLowerCase];
                      if (!childNode) {
                        childNode = {
                          name: level,
                          fullPath: node.fullPath + "/" + level,
                          entryList: [],
                          nodes: [],
                          nodeNameLowerToNodeMap: {}
                        };

                        childNode.nodeId = "folder---" + childNode.fullPath;

                        node.nodeNameLowerToNodeMap[levelLowerCase] = childNode;
                        node.nodes.push(childNode);
                      }

                      placeEntryInNode(childNode, entry, levelIndex + 1);
                    }
                  };

                  for (let entry of entryList) {
                    placeEntryInNode(rootNode, entry, 0);
                  }

                  var dataSet = {
                    entryList: entryList,
                    rootNode: rootNode
                  };

                  return dataSet;
                }
              }
            ]
          }
        };
      }
      

      return report;
    }

    public static findMatchingEntries(entryList, searchText) {
      let results: any = {
      };

      if (!searchText) {
        results.noSearchString = true;
        return results;
      }
      else {
        searchText = searchText.trim();
        if (!searchText) {
          results.noSearchString = true;
          return results;
        }
      }

      let parts = searchText.toLowerCase().split(" ");

      // For every entry where a part of a level matches every part of search, we will flag a potential match.
      let matchDetailList = [];

      for (let entry of entryList) {
        let missingPartCount = 0;
        let overallPartMatchCount = 0;
        for (let part of parts) {
          part = part.trim();
          if (part) {
            let partMatchCount = 0;
            for (let level of entry.levelsLowerCase) {
              if (level.indexOf(part) >= 0) {
                partMatchCount++;
                overallPartMatchCount++;
              }
            }
            if (partMatchCount == 0) {
              missingPartCount++;
            }
          }
        }

        if (missingPartCount == 0 && overallPartMatchCount > 0) {
          let matchDetail = {
            entry: entry,
            overallPartMatchCount: overallPartMatchCount
          };

          matchDetailList.push(matchDetail);
        }
      }

      results.matches = matchDetailList;

      return results;
    }


    public static _createReportDiv(reportLabel, entry, hasReportEditPermission) {
      if (entry.report) {
        var reportRef = entry.report;
        var reportDiv = $("<div>");

        var reportHref = Solovis.Reports.ReportLinker.getReportLink({ reportCode: reportRef.code });
        var reportLink = $("<a>").text(reportLabel).appendTo(reportDiv);

        $(reportLink).click(function (e) {
          (window as any).location = reportHref;
        });

        $(reportLink).bind("contextmenu", function (e) {
          e.preventDefault();

          var links = [];
          links.push({ label: "View Report", href: reportHref });

          var reportMetadataLink = Solovis.Reports.ReportLinker.getReportLink({
            reportCode: "C3964A46-4663-4646-B9A4-8F4D91EF5509",
            parameters: { report: { code: reportRef.code } },
            autoRun: true,
            collapseConfigSection: true
          });

          links.push({ label: "Report Metadata", href: reportMetadataLink });

          if (hasReportEditPermission) {
            links.push(
              { label: "Report Definition", href: "~/DataManagement/ReportEditor/ReportDefinition?code=" + encodeURIComponent(reportRef.code) }
            );
          }

          Solovis.UI.PopupLinkPanel.showLinks({
            links: links,
            offset: { left: e.pageX, top: e.pageY }
          });

          return false;
        });

        Solovis.Reports.ReportLinker.setupSolovisRefLink(reportLink, { type: "report", value: { code: reportRef.code } });

        return reportDiv;
      }
      else if (entry.link) {
        var linkRef = entry.link;
        var linkDiv = $("<div>");

        var actualLink = $("<a>").appendTo(linkDiv);
        actualLink.text(linkRef.name);
        if (linkRef.url) {
          actualLink.attr("href", linkRef.url);
        }
        else {
          var linkUrl = Solovis.resolveUrl("~/Report/GoToFeaturedReportLink?code=" + encodeURIComponent(linkRef.code));
          actualLink.attr("href", linkUrl);
        }

        return linkDiv;
      }
      else {
        var unknownDiv = $("<div>");
        unknownDiv.text("Unknown Entry");
        return unknownDiv;
      }
    }
  }


  class LocalReportSearchResultControl extends Solovis.UI.BaseControl {

    constructor(options) {
      super(options);
    }

    public doRender() {
    }

    public setMatches(matches) {
      $(this.container).html("");

      $(this.container).scrollTop(0);

      let resultsDiv = $("<div>").css("margin-top", "10px");

      if (matches && matches.length > 0) {
        let hasReportEditPermission = Solovis.Portal.CachedPermissions.doesUserHavePermission("ReportEdit");

        $(matches).each(function (i, match: any) {
          let entry = match.entry;

          let entryDiv = ReportLibraryReportGenerator._createReportDiv(
            entry.name + (entry.category ? " (" + entry.category + ")" : ""),
            entry,
            hasReportEditPermission);

          entryDiv.appendTo(resultsDiv);
        });
      }
      else {
        $("<span>").text("No matching reports found.").appendTo(resultsDiv);
      }

      resultsDiv.appendTo(this.container);
    }
  }


  class ReportLibraryDisplayControl extends Solovis.UI.BaseControl {

    private static _GridViewId = 1;
    private static _TreeListViewId = 2;

    private _reportControl;
    private _reportListDataSet;

    private _toolbarDiv;

    private _contentDiv;

    private _searchBoxInstance;
    private _drawerInstance;

    private _reportListDiv;
    private _reportListControlHost: Solovis.UI.ControlHost;
    private _reportTreeListControl;
    private _reportListExpandedTreeControl;

    private _reportSearchDiv;
    private _reportSearchControl;

    private _activeAllReportViewId = ReportLibraryDisplayControl._GridViewId;

    private _quickStartControl: QuickStartControl;
    private _quickStartPanelDiv;
    private _quickStartPanelControlHost;

    constructor(options) {
      super(options);

      this._reportControl = options.reportControl;
      this._reportListDataSet = options.reportListDataSet;
    }

    public doRender() {
      const enabled = Solovis.UX.Utils.isNewUxEnabled();
      if (enabled) {
        this.doRenderNew();
      } else {
        this.doRenderClassic();
      }
    }

    private async doRenderNew() {
      // NOTE: turns off the classic space available check as it isn't needed in the new
      this.updateSpaceAvailable = () => undefined;
      await Solovis.UX.Utils.placeComponent(
        "ReportLibraryPage",
        this.container[0],
        {}
      );
    }

    private doRenderClassic() {
      let self = this;

      let hasReportEditPermission = Solovis.Portal.CachedPermissions.doesUserHavePermission("ReportEdit");

      let debouncedUpdateReportDisplay = _.debounce(() => this._updateReportDisplay(), 300);

      this._toolbarDiv = $("<div>").appendTo(this.container);

      $(this._toolbarDiv).dxToolbar({
        items: [
          {
            widget: "dxButton",
            location: "before",
            options: {
              icon: "menu",
              hint: "Quick Start",
              onClick: function () {
                self._drawerInstance.toggle();
                self.updateSpaceAvailable();
              }
            }
          },
          {
            widget: 'dxTextBox',
            location: 'before',
            options: {
              placeholder: "Search for a report",
              width: 500,
              valueChangeEvent: "keyup",
              onKeyUp: function (e) {
                // TODO: Is there better way to retrieve this once toolbar is created?
                self._searchBoxInstance = this;

                if (e.event && e.event.keyCode == 27) {
                  // Escape pressed - Clear search box.                                                                                                   
                  self._searchBoxInstance.option('value', '');
                }
                debouncedUpdateReportDisplay();
              }
            }
          },
          // NOTE: We're hiding the toggle between grid and tree view for now until we add more details to the tree view.
          /*
          {
              widget: 'dxButtonGroup',
              location: 'after',
              options: {                            
                  items: [
                      { id: ReportLibraryDisplayControl._GridViewId, icon: "mediumiconslayout", hint: "Grid View" },
                      { id: ReportLibraryDisplayControl._TreeListViewId, icon: "activefolder", hint: "Tree View" }
                  ],
                  keyExpr: "id",                                                  
                  selectedItemKeys: [self._activeAllReportViewId],
                  onItemClick: function (e) {                                
                      let selectedItemsKeys = this.option("selectedItemKeys");
                      self._activeAllReportViewId = selectedItemsKeys[0];
                      self._recreateAllReportView();
                  }
              }
          }*/
        ]
      });

      // Setup wrapper div for the drawer.
      let drawerDiv = $("<div>").appendTo(this.container);

      this._contentDiv = $("<div>").appendTo(drawerDiv);

      // Main report list.
      this._reportListDiv = $("<div>").appendTo(this._contentDiv);
      this._reportListControlHost = new Solovis.UI.ControlHost({
        container: this._reportListDiv
      });

      // Search results.
      this._reportSearchDiv = $("<div>").css("overflow-y", "auto").css("display", "none").appendTo(this._contentDiv);

      this._reportSearchControl = new LocalReportSearchResultControl({
        controlHost: this._reportSearchDiv
      });
      this._reportSearchControl.setAsCurrentControl();

      // Quick start panel.
      this._quickStartPanelDiv = $("<div>").css("overflow-y", "auto").css("display", "none").appendTo(this._contentDiv);
      this._quickStartPanelControlHost = new Solovis.UI.ControlHost({
        container: this._quickStartPanelDiv
      });


      // Setup the drawer.
      this._drawerInstance = ($(drawerDiv) as any).dxDrawer({
        opened: false,
        height: 400,
        template: function () {
          let drawerDiv = $("<div>").css("width", 250);

          self._quickStartControl = new QuickStartControl({
            controlHost: drawerDiv,
            quickStartPanelControlHost: self._quickStartPanelControlHost,
            showQuickStartPanelCallback: () => self._showQuickStartPanel(),
            hideQuickStartPanelCallback: () => self._showFullReportList()
          });
          self._quickStartControl.setAsCurrentControl();

          return drawerDiv;
        }
      }).dxDrawer("instance");

      // We must remove dx-widget class because it messes up our fonts.
      $(drawerDiv).removeClass('dx-widget');

      this._recreateAllReportView();
      this.updateSpaceAvailable();
    }

    private _recreateAllReportView() {
      let hasReportEditPermission = Solovis.Portal.CachedPermissions.doesUserHavePermission("ReportEdit");

      if (this._activeAllReportViewId == ReportLibraryDisplayControl._TreeListViewId) {
        $(this._reportListDiv).css("overflow", "hidden");

        this._reportTreeListControl = new ReportTreeListControl({
          controlHost: this._reportListDiv,
          reportListDataSet: this._reportListDataSet,
          userHasReportEditPermission: hasReportEditPermission
        });
        this._reportListControlHost.setCurrentControl(this._reportTreeListControl);
      }
      else {
        $(this._reportListDiv).css("overflow", "auto");

        this._reportListExpandedTreeControl = new ReportListExpandedTreeControl({
          controlHost: this._reportListDiv,
          reportListDataSet: this._reportListDataSet,
          userHasReportEditPermission: hasReportEditPermission
        });
        this._reportListControlHost.setCurrentControl(this._reportListExpandedTreeControl);
      }

      this.updateSpaceAvailable();
      this._showFullReportList();
    }

    private _updateReportDisplay() {
      if (this._searchBoxInstance) {
        let searchText = this._searchBoxInstance.option("value");

        let searchResult = ReportLibraryReportGenerator.findMatchingEntries(this._reportListDataSet.entryList, searchText);
        if (searchResult.noSearchString) {
          this._showFullReportList();
        }
        else {
          this._showSearchResults();
          this._reportSearchControl.setMatches(searchResult.matches);
        }
      }
    }

    private _showSearchResults() {
      $(this._reportListDiv).css("display", "none");
      $(this._quickStartPanelDiv).css("display", "none");
      $(this._reportSearchDiv).css("display", "block");
    }

    private _showFullReportList() {
      $(this._reportSearchDiv).css("display", "none");
      $(this._quickStartPanelDiv).css("display", "none");
      $(this._reportListDiv).css("display", "block");
    }

    private _showQuickStartPanel() {
      $(this._reportListDiv).css("display", "none");
      $(this._reportSearchDiv).css("display", "none");
      $(this._quickStartPanelDiv).css("display", "block");
    }

    public updateSpaceAvailable() {
      let contentWidth = $(this._reportControl.container).innerWidth();

      let height = $(this._reportControl.container).innerHeight() - $(this._toolbarDiv).outerHeight();

      if (this._drawerInstance) {
        this._drawerInstance.option("height", height);
      }
      this._reportListDiv.outerHeight(height - 10);
      this._reportSearchDiv.outerHeight(height - 10);
      this._quickStartPanelDiv.outerHeight(height - 10);

      if (this._reportTreeListControl) {
        this._reportTreeListControl.updateSpaceAvailable(contentWidth, height);
      }

      if (this._quickStartControl) {
        this._quickStartControl.updateSpaceAvailable(250, height);
      }
    }
  }
}
